import httpClient from 'utils/httpClient.js';

const path = '/warranty-period';

export const getWarrantyPeriods = (params = {}) => httpClient.get(path, { params });
export const getWarrantyPeriod = (id) => httpClient.get(`${path}/${id}`);
export const createWarrantyPeriod = (payload) => httpClient.post(path, payload);
export const updateWarrantyPeriod = (id, payload) => httpClient.put(`${path}/${id}`, payload);
export const deleteWarrantyPeriod = (id) => httpClient.delete(`${path}/${id}`);
